/**
 * Created by karora on 14/10/19.
 */

export class FuelFill {
  hubid: number;            // HubID related to tank
  fill_timestamp: string;   // When the fill occurred
  fill_amount: number;      // Litres of oil, or ??? of other fuel
  tank_filled: boolean;     // If this completely filled the tank
}
